import { useEffect, useCallback } from 'react'
import { useSessionStore } from '../stores/sessionStore'
import type { MatrixCellStatus } from '@range-reader/shared'

const COLS = 13

export function useMatrixKeyboard(containerRef: React.RefObject<HTMLElement | null>) {
  const { focusedCell, setFocusedCell, toggleCell, matrixState, phase } = useSessionStore()

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (phase === 'SHOWDOWN' || phase === 'IDLE' || phase === 'LOADING_HAND') return

    switch (e.key) {
      case 'ArrowRight': {
        e.preventDefault()
        const next = focusedCell % COLS === COLS - 1
          ? focusedCell - COLS + 1  // wrap to start of row
          : focusedCell + 1
        setFocusedCell(next)
        break
      }
      case 'ArrowLeft': {
        e.preventDefault()
        const next = focusedCell % COLS === 0
          ? focusedCell + COLS - 1  // wrap to end of row
          : focusedCell - 1
        setFocusedCell(next)
        break
      }
      case 'ArrowDown': {
        e.preventDefault()
        const next = focusedCell + COLS >= 169
          ? focusedCell % COLS  // wrap to top of column
          : focusedCell + COLS
        setFocusedCell(next)
        break
      }
      case 'ArrowUp': {
        e.preventDefault()
        const next = focusedCell - COLS < 0
          ? 169 - COLS + (focusedCell % COLS)  // wrap to bottom of column
          : focusedCell - COLS
        setFocusedCell(next)
        break
      }
      case ' ':
      case 'Enter': {
        e.preventDefault()
        toggleCell(focusedCell)
        break
      }
    }
  }, [focusedCell, setFocusedCell, toggleCell, phase])

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    el.addEventListener('keydown', handleKeyDown)
    return () => el.removeEventListener('keydown', handleKeyDown)
  }, [containerRef, handleKeyDown])
}
